import React from 'react';
import Modal from 'react-awesome-modal';
import Button from '@material-ui/core/Button';
import { createMuiTheme, makeStyles } from '@material-ui/core/styles';
import { green, red } from '@material-ui/core/colors';
import AppColors from '../assets/colors'
import { useTranslation } from 'react-i18next';

const WishItemCartMessage = ({visible, onClick})=> {

  const { t, i18n } = useTranslation('common');

  const useStyles = makeStyles((theme) => ({
      margin: {
        margin: theme.spacing(1),
      },
    }));
    
    const theme = createMuiTheme({
      palette: {
        primary: red,
        secondary: green,
      },
    });
    const classes = useStyles();
    
        return (
            <section>
                <Modal visible={visible} width="350" height="100" effect="fadeInUp" >
                    <div className="modalContainer">
                    <div className="modalTitleContainer">
                    <p style={{color: 'grey', marginTop: 10}}>{t('common:product-added-cart')}</p>
                    </div>
                    <div className="confirmationModalButtonsView">
                     <Button 
                    style={{color: AppColors.secondary, fontSize: 18}} 
                    onClick={onClick}
                    >OK</Button>
                    </div>
                    </div>
                </Modal>
            </section>
        );
}

export default WishItemCartMessage;